<template>
    <b-modal
        id="modal-ostdataselector"
        ref="modal"
        size="xl"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <card-fix-ost :prodDate="prodDate" />
    </b-modal>
</template>
<script>
import DateHelper from '../../models/DateHelper';
import { loadList, loadItem } from '../../models/DataHelper';
import CardFixOst from '../externcomm/CardFixOst.vue';
export default {
    name: 'OstDataSelector',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            selected: []
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        prodDate: {
            default: null
        }
    },
    watch: {},
    components: { CardFixOst },
    computed: {},
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        handleSubmit() {
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-ostdataselector');
            });
        },
        change(visible) {
            this.$emit('change', visible);
        }
    },
    mounted() {},
    created() {}
};
</script>

<style scoped>
::v-deep .table > tbody > tr.b-table-row-selected,
::v-deep .table > tbody > tr.b-table-row-selected > td,
::v-deep .table > tbody > tr.b-table-row-selected > th {
    background-color: #00a1de;
    color: ghostwhite !important;
}
.overflow-class /deep/ .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
</style>

